<template>
  <v-container fluid class="grow pa-0" style="height: 100%">
    <v-row dense style="height: 100%">
      <v-col cols="6">
        <ScrollerHandler style="max-height: calc(100vh - 132px)" ref="itemScroller">
          <template #prepend>
            <v-alert dense color="secondary darken-3" dark style="position:sticky; left: 0; top: 0; right: 0; margin-bottom: 4px; z-index: 1; min-height: 3.8rem; line-height: 1.1em; font-size: 13px">
              <transition name="slide" mode="out-in">
                <v-row key="2" align="center">
                  <v-col cols="6">
                    <div><T>Скидка</T>: {{Math.abs(validated_order.discount_sum | 0).toFixed(2)}}</div>
                    <div><T>Наценка</T>: {{(validated_order.markup_sum | 0).toFixed(2)}}</div>
                    <div><T>Итог</T>: {{(validated_order.order_total | 0).toFixed(2)}}</div>
                  </v-col>
                  <v-col cols="6">
                    <div><T>Стол</T>: {{validated_order.table ? validated_order.table.name : ''}}</div>
                    <div><T>Кат.</T>: {{validated_order.order_category ? validated_order.order_category.name : ''}}</div>
                    <div><T>Готовность</T>: {{validated_order.cook_mins === undefined ? 0 : validated_order.cook_mins === 0 ? '---' : validated_order.cook_mins}}</div>
                  </v-col>
                </v-row>      
              </transition>
            </v-alert>
          </template>
          <template #scroller>
            
            <v-list dense class="order-content">
              <transition-group name="slide" duration="100">
                <OrderedItem v-for="item in validated_order.items" :key="item.line_guid" :item="item" 
                  @dec="dec(item.line_guid)" 
                  @inc="inc(item.line_guid)" 
                  :price_address="order_type" 
                  :validating="validating"
                />
                <DiscountItem v-for="item in (validated_order.markups || [])" :key="item.id" :item="item" /> 
                <DiscountItem v-for="item in (validated_order.discounts || [])" :key="item.id" :item="item" /> 
              </transition-group>
            </v-list>
          </template>
        </ScrollerHandler>
      </v-col>
      <v-col cols="6">
        <ScrollerHandler style="max-height: calc(100vh - 132px)">
          <MenuNavigator key="1" :loading="loading" @click:item="itemAdd" :price_address="order_type" :validating="validating" />
        </ScrollerHandler>
      </v-col>
    </v-row>
    <v-dialog :value="new_portion !== undefined" @click:outside="new_portion = undefined"  persistent scrollable max-width="600px">
      <ModifiersEditor v-if="new_portion !== undefined" @done="pushPortion(new_portion); new_portion = undefined" :scheme="new_portion.product.modischeme_ref" v-model="new_portion.modifiers" :item_name="new_portion.product.alt_name || new_portion.product.name" />
    </v-dialog>
  </v-container>
</template>

<script>
import ModifiersEditor from './ModifiersEditor.vue'
import ScrollerHandler from '../../../scroller_handler'
import MenuNavigator from './MenuNavigator.vue'
import OrderedItem from './OrderedItem.vue'
import DiscountItem from './DiscountItem.vue'

export default {
  props: {
    validating: Boolean,
    loading: Boolean,
    validated_order: Object,
    order_type: String,
    deliveryZone: [Object, undefined]
  },
  data: () => ({
    new_portion: undefined
  }),
  
  methods: {
    itemAdd(item) {
      if (item.modischeme_ref != undefined) {
        this.new_portion = {
          id: Math.random()*1000000000,
          product: item,
          quantity: 1,
          modifiers: []
        }
      } else {
        this.pushPortion({
          id: Math.random()*1000000000,
          product: item,
          quantity: 1,
          modifiers: []
        })
      }
    },
    pushPortion(portion) {
      this.$emit('pushItem', portion)
    },
    dec(guid) {
      this.$emit('decItem', guid)
    },
    inc(guid) {
      let orderItems = this.$store.getters.orderItems
      let existantLine = orderItems[guid]

      if (existantLine.product.add_line_mode === "almOnePortion") {
        this.itemAdd(existantLine.product)
      } else {
        this.$emit('incItem', guid)
      }
    }
  },
  components: {
    ScrollerHandler,
    MenuNavigator,
    OrderedItem,
    ModifiersEditor,
    DiscountItem
  }
}
</script>

<style>
.order-content .v-list-item:nth-child(odd){
	background: #f4f4f4;
}
</style>